import { OverviewMap, ScaleLine, MousePosition } from "ol/control";
import { createStringXY } from "ol/coordinate";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";

class MapControlsService {

    addOverviewMap(map, onActivate) {
        const overview = new OverviewMap({
            layers: [
                new TileLayer({
                    source: new OSM()
                })
            ],
            collapsed: false,
            collapsible: false,
            className: "ol-overviewmap ol-custom-overviewmap"
        });

        map.addControl(overview);

        if (typeof onActivate === "function") {
            const element = overview.element;
            const activate = (event) => {
                if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") {
                    return;
                }

                if (event.type === "keydown") {
                    event.preventDefault();
                }

                onActivate();
            };

            element.classList.add("ol-custom-overviewmap--interactive");
            element.setAttribute("role", "button");
            element.setAttribute("tabindex", "0");
            element.setAttribute("title", "Cambiar mapa base");
            element.setAttribute("aria-label", "Abrir panel para cambiar mapa base");
            element.addEventListener("click", activate);
            element.addEventListener("keydown", activate);

            overview.removeActivationListeners = () => {
                element.removeEventListener("click", activate);
                element.removeEventListener("keydown", activate);
            };
        }

        return overview;
    }

    addScaleLine(map) {
        const scale = new ScaleLine();
        map.addControl(scale);
    }

    addMousePosition(map) {
        const mousePosition = new MousePosition({
            coordinateFormat: createStringXY(4),
            projection: "EPSG:4326",
            className: "ol-mouse-position ol-custom-mouseposition"
        });
        map.addControl(mousePosition);
    }

    addDefaultControls(map, options = {}) {
        const overview = this.addOverviewMap(map, options.onOverviewActivate);
        this.addScaleLine(map);
        this.addMousePosition(map);

        return { overview };
    }

}

export const mapControlsService = new MapControlsService();
